<template>
  <div class="columns is-multiline invoice-information-view">
    <div class="column is-12">
      <subtitle-component :size="5">
        <translate>First you need to update your invoice information</translate>
      </subtitle-component>
      <subtitle-component :size="5">
        <translate>Are you still connected to the following company?</translate>
      </subtitle-component>
    </div>
    <div class="column is-12">
      <div class="flex-table">
        <div class="flex-table-row flex-table-body">
          <div class="flex-table-row-item" data-heading="CompanyName">{{ customer.invoicing.companyName }}</div>
          <div class="flex-table-row-item" data-heading="Options">
            <div class="buttons-wrapper">
              <button class="button is-success is-outlined is-1" v-translate @click="setupEditSameCompanyInvoiceInformation()">Yes</button>
              <button class="button is-success is-outlined is-1" v-translate @click="setupEditDifferentCompanyInvoiceInformation()">No</button>
            </div>
          </div>
          <card-modal-component
            :show="show_modal"
            transition="fade"
            ref="modal"
            :options="{ hasOkBtn: { text: 'Save' }, hasCancelBtn: { enabled: true }}"
            @handleOk="updateInvoiceInformation($event)"
            @handleCancel="toggleModal()"
            @deactivate="toggleModal()"
            title="Update invoice information">
            <template slot="card-content">
              <form-component
                v-for="formDescriptor in formDescriptors"
                :formDescriptor="formDescriptor"
                :formData="getFormDataForDescriptor(formDescriptor)"
                :key="formDescriptor.id">
              </form-component>
            </template>
          </card-modal-component>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapState, mapActions } from 'vuex'
  import { errorHandler, formHandlerMixin } from '@/mixins/mixins'
  import SubtitleComponent from '@/components/layout/SubTitleComponent'
  import FormComponent from '@/components/form/FormComponent.vue'
  import CardModalComponent
    from '@/components/layout/modal/CardModalComponent.vue'

  export default {
    name: 'invoice-information-view',
    mixins: [errorHandler, formHandlerMixin],
    components: {
      CardModalComponent,
      FormComponent,
      SubtitleComponent
    },
    data () {
      return {
        show_modal: false,
        redirectPath: { name: 'DashboardView' }
      }
    },
    props: {
      customer: {
        type: Object,
        required: true
      }
    },
    computed: {
      ...mapState({
        formDescriptors: state => state.customerEditModule.CustomerEditFormDescriptors,
        formDatas: state => state.customerEditModule.CustomerEditFormDatas,
        authUser: state => state.authModule.authUser
      })
    },
    methods: {
      ...mapActions([
        'setupCustomerUpdateInvoiceInformationForm',
        'setupCustomerNewInvoiceInformationForm',
        'updateCustomerInvoiceInformation',
        'errorMessage',
        'successMessage'
      ]),
      toggleModal () {
        this.show_modal = !this.show_modal
      },
      setupEditSameCompanyInvoiceInformation () {
        this.setupCustomerUpdateInvoiceInformationForm(this.authUser.profile.id).then(() => {
          // this.isFormActive = true
        }).catch((err) => {
          this.handleError(err)
        })
        this.toggleModal()
      },
      setupEditDifferentCompanyInvoiceInformation () {
        this.setupCustomerNewInvoiceInformationForm(this.authUser.profile.id).then(() => {
          // this.isFormActive = true
        }).catch((err) => {
          this.handleError(err)
        })
        this.toggleModal()
      },
      updateInvoiceInformation (btn) {
        let requestData = {
          formDatas: this.formDatas,
          profileId: this.authUser.profile.id
        }
        this.submitRequest = this.updateCustomerInvoiceInformation
        this.submitForm(requestData, btn, this.updateInvoiceInformationCallback)
      },
      updateInvoiceInformationCallback (response) {
        this.successMessage('Invoice information updated')
        this.toggleModal()
        window.location.reload()
      }
    }
  }
</script>

<style>
.buttons-wrapper {
  display: flex;
  justify-content: flex-end; /* pushes buttons to the right */
  gap: 0.5rem;               /* small space between them */
  align-items: center;
}
</style>
